import { IUnauthorizedRoute } from './routesTypes';
import { RouteRecordRaw } from 'vue-router';
const routes: RouteRecordRaw[] = [
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/RegisterView.vue'),
    meta: {
      layout: 'AuthLayout',
      layoutMode: 'registration',
      title: 'Регистрация',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: {
      layout: 'AuthLayout',
      layoutMode: 'login',
      title: 'Авторизация',
    },
  },
  {
    path: '/mp',
    name: 'MobileApp',
    component: () => import('@/views/auth/MobileApp.vue'),
    meta: {
      layout: 'EmptyLayout',
      title: 'Скачать мобильное приложение',
    },
  },
  {
    path: '/instructions-for-passes',
    name: 'InstructionsForPasses',
    component: () =>
      import('@/views/instructions-for-passes/InstructionsForPasses.vue'),
    meta: {
      layout: 'EmptyLayout',
      title: 'Порядок оформления пропуска',
    },
  },
  {
    path: '/tech-support',
    name: 'TechSupport',
    component: () => import('@/views/techSupport/TechSupportView.vue'),
    meta: {
      layout: 'TechSupportLayout',
      title: 'Чат поддержки',
    },
  },

  {
    path: '/dom-24',
    name: 'YourHouseIsUnderYourControl',
    component: () =>
      import('../views/specialArticles/YourHouseIsUnderYourControl.vue'),
    meta: {
      layout: 'NonAuthorizedPagesLayout',
      title: 'Ваш дом под вашим контролем',
    },
  },

  {
    path: '/triniti',
    name: 'YourHouseIsUnderYourControlAlt',
    component: () =>
      import('../views/specialArticles/YourHouseIsUnderYourControlAlt.vue'),
    meta: {
      layout: 'NonAuthorizedPagesLayout',
      title: 'Ваш дом под вашим контролем',
    },
  },

  {
    path: '/chat-bot-personal-data-policy',
    name: 'ChatBotPersonalDataPolicy',
    component: () =>
      import('../views/chat-bot-personal-data/ChatBotPersonalDataPolicy.vue'),
    meta: {
      layout: 'NonAuthorizedPagesLayout',
      title: 'Политика обработки персональных данных',
    },
  },

  {
    path: '/chat-bot-personal-data-agreement',
    name: 'ChatBotPersonalDataAgreement',
    component: () =>
      import(
        '../views/chat-bot-personal-data/ChatBotPersonalDataAgreement.vue'
      ),
    meta: {
      layout: 'NonAuthorizedPagesLayout',
      title: 'Согласие на обработку персональных данных',
    },
  },

  {
    path: '/:base/chat-bot-personal-data-policy-frame',
    name: 'ChatBotPersonalDataPolicyFrame',
    component: () =>
      import(
        '../views/chat-bot-personal-data/ChatBotPersonalDataPolicyFrame.vue'
      ),
    meta: {
      layout: 'NonAuthorizedPagesLayout',
      title: 'Политика обработки персональных данных',
    },
  },

  {
    path: '/:base/chat-bot-personal-data-agreement-frame',
    name: 'ChatBotPersonalDataAgreementFrame',
    component: () =>
      import(
        '../views/chat-bot-personal-data/ChatBotPersonalDataAgreementFrame.vue'
      ),
    meta: {
      layout: 'NonAuthorizedPagesLayout',
      title: 'Согласие на обработку персональных данных',
    },
  },

  {
    path: '/payment-invoice/:token',
    name: 'PaymentInvoice',
    component: () => import('../views/payment/PaymentInvoice.vue'),
    meta: {
      layout: 'EmptyLayout',
      title: 'Счет на оплату',
    },
  },

  {
    path: '/open-poll/:code',
    name: 'OpenPoll',
    component: () => import('@/views/open-polls/OpenPollView.vue'),
    meta: {
      layout: 'EmptyLayout',
      title: 'Опрос',
    },
  },

  {
    path: '/open-poll-result/:code',
    name: 'OpenPollResultView',
    component: () => import('@/views/open-polls/OpenPollResultView.vue'),
    meta: {
      layout: 'EmptyLayout',
      title: 'Результат опроса',
    },
  },

  // UI-Kit --------------------------------------------------------------------
  {
    path: '/ui-kit/',
    name: 'UiKit',
    component: () => import('@/views/uiKit/IndexView.vue'),
    meta: {
      layout: 'UiKitLayout',
    },
    children: [
      {
        path: 'colors',
        name: 'UiKit.Colors',
        component: () => import('@/views/uiKit/ColorsView/ColorsView.vue'),
        meta: {
          title: 'Цветовая система',
        },
      },
      {
        path: 'typography',
        name: 'UiKit.Typography',
        component: () =>
          import('@/views/uiKit/TypographyView/TypographyView.vue'),
        meta: {
          title: 'Типографика',
        },
      },
      {
        path: 'icons',
        name: 'UiKit.Icons',
        component: () => import('@/views/uiKit/IconsView/IconsView.vue'),
        meta: {
          title: 'Иконки',
        },
      },
      {
        path: 'buttons',
        name: 'UiKit.Buttons',
        component: () => import('@/views/uiKit/ButtonsView/ButtonsView.vue'),
        meta: {
          title: 'Кнопки',
        },
      },
      {
        path: 'badges',
        name: 'UiKit.Badges',
        component: () => import('@/views/uiKit/BadgesView/BadgesView.vue'),
        meta: {
          title: 'Баджи и ярлыки',
        },
      },
      {
        path: 'lists',
        name: 'UiKit.Lists',
        component: () => import('@/views/uiKit/ListsView/ListsView.vue'),
        meta: {
          title: 'Списки',
        },
      },
      {
        path: 'cards',
        name: 'UiKit.Cards',
        component: () => import('@/views/uiKit/CardsView/CardsView.vue'),
        meta: {
          title: 'Карточки',
        },
      },
      {
        path: 'forms',
        name: 'UiKit.Forms',
        component: () => import('@/views/uiKit/FormsView/FormsView.vue'),
        meta: {
          title: 'Формы',
        },
      },
      {
        path: 'other',
        name: 'UiKit.Other',
        component: () => import('@/views/uiKit/OtherView/OtherView.vue'),
        meta: {
          title: 'Разное',
        },
      },
      {
        path: 'chat',
        name: 'UiKit.Chat',
        component: () => import('@/views/uiKit/ChatView/ChatView.vue'),
        meta: {
          title: 'Чат',
        },
      },
    ],
  },
];

export const unauthorizedRoutes: IUnauthorizedRoute[] = routes.map((route) => ({
  ...route,
  meta: { ...route.meta, requiresAuth: false },
}));
